// ============================================================================
// REPOSITORY: TimesheetManagerRepository — CRUD timesheet + faturamento batch
// ARQUIVO: src/services/TimesheetManagerRepository.js
// ============================================================================

import { collection, doc, addDoc, getDocs, query, orderBy, deleteDoc, writeBatch, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function loadTimesheetEntries(appId = DEFAULT_APP_ID) {
  const ref = collection(db, ...FS.timesheetEntries(appId));
  const q = query(ref, orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function addTimesheetEntry(data, appId = DEFAULT_APP_ID) {
  const ref = collection(db, ...FS.timesheetEntries(appId));
  await addDoc(ref, { ...data, createdAt: serverTimestamp() });
}

export async function deleteTimesheetEntry(id, appId = DEFAULT_APP_ID) {
  await deleteDoc(doc(db, ...FS.timesheetEntries(appId), id));
}

export async function createBillingBatch(billingData, selectedIds, entries, appId = DEFAULT_APP_ID) {
  const batch = writeBatch(db);
  const ledgerRef = doc(collection(db, ...FS.financialLedger(appId)));
  const firstEntry = entries.find((e) => selectedIds.includes(e.id)) || {};
  const targetClientId = String(firstEntry?.clientId || '').trim();

  batch.set(ledgerRef, {
    description: billingData.description,
    value: billingData.totalValue,
    date: billingData.dueDate,
    competenceDate: new Date().toISOString().slice(0, 7),
    group: 'RECEITA_BRUTA',
    category: 'Honorários por Hora',
    linkedName: entries.find((e) => selectedIds.includes(e.id))?.clientName || 'Diversos',
    linkedToType: 'CLIENT',
    account: 'A Receber',
    movementType: 'CREDIT',
    status: 'PENDING',
    createdAt: serverTimestamp(),
  });

  selectedIds.forEach((id) => {
    const tsRef = doc(db, ...FS.timesheetEntries(appId), id);
    batch.update(tsRef, { billed: true, billedAt: serverTimestamp() });
  });

  await batch.commit();
  return { ledgerId: ledgerRef.id, targetClientId };
}
